import React from "react";
import styled from "styled-components";

function SectionsData({ label, text, image }) {
    return (
        <Container>
            <Label>{label}</Label>
            {Array.isArray(text) ? (
                text.map((el, index) => <Text key={index}>{el}</Text>)
            ) : (
                <Text>{text}</Text>
            )}
            {image && (
                <Image
                    href={image?.url}
                    target="_blank"
                >
                    {image?.name || <Label>No data</Label>}
                </Image>
            )}
            {!text && !image && <Label>No data</Label>}
        </Container>
    );
}
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 22%;
    margin-right: 20px;
    margin-bottom: 50px;
    line-break: anywhere;
`;
const Label = styled.span`
    font-size: 16px;
    color: #98a2b3;
    margin-bottom: 15px;
`;
const Text = styled.p`
    font-size: 18px;
    font-weight: bold;
`;
const Image = styled.a`
    font-size: 18px;
    font-weight: bold;
`;

export default SectionsData;
